import {Component, HostListener, OnInit} from '@angular/core';
import {RoutingService, WebsocketService, AppToastrService, StorageService, ChatService} from '../../services';
import {DocumentsService} from 'app/services/documents.service';
import {Attachment, Message} from '../../models'
import * as moment from 'moment';

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss']
})
export class ChatPageComponent implements OnInit {
    clientID: number;
    agentID: number;
    messages: any = [];
    newMessage: string;
    fileUpload: any;
    fileName: string;
    chatID: number;
    chatIdSecond: number;
    unreadPos: number;
    showChat: boolean;

    constructor(private route: RoutingService,
                private  websocket: WebsocketService,
                private toast: AppToastrService,
                private chat: ChatService,
                private storage: StorageService,
                private documentsService: DocumentsService) {
        this.clientID = this.storage.userId;
        this.storage.chatCounter = 0;
    }

    @HostListener('window:keydown', ['$event']) keyEvent(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey) {
            this.sendMessage();
        }
    }

    ngOnInit() {
        this.getMessages();
    }

    compareDates(currentDate, nexDate) {
        return moment(currentDate).format('YYYY/MM/DD') !== moment(nexDate).format('YYYY/MM/DD');
    }

    updateMsg(msg) {
        if (msg.read_at === null && msg.reply_to !== this.clientID) {
            this.chat.updateMessage(msg).subscribe((msgR) => {
                /* this.messages.map((item) => {
                     if (item.id === msgR.id) {
                         item.read_at = msgR.read_at;
                     }
                 });*/
            }, (err) => {
                this.toast.showToastFromError(err);
            });
        }
    }

    updateMessage(chatId) {
        this.websocket.update_message(chatId).subscribe(
            msg => {
                setTimeout(() => {
                    const msgR = new Message().setFromApiModel(msg);
                    this.messages.map((item) => {
                        if (item.id === msgR.id) {
                            item.read_at = msgR.read_at;
                            this.storage.chatCounter = 0;
                        }
                    });
                }, 3000);
            },
            err => {
                console.log(err);
                this.toast.showToastFromError(err);
            }
        );
    }

    getMessages() {
        this.showChat = false;
        this.chat.getMessages(this.clientID).subscribe((list) => {
            if (list.messages) {
                this.agentID = list.agent_id;
                this.groupMessage(list.messages);
                if (list.messages.length > 0) {
                    this.chatID = this.messages[this.messages.length - 1].chat_id;
                    this.messages.map((item) => {
                        if (item.chat_id !== this.chatID && !this.chatIdSecond) {
                            this.chatIdSecond = item.chat_id;
                            this.getNewFile(this.chatIdSecond);
                            this.updateMessage(this.chatIdSecond);
                        }
                    });
                }
                this.getNewMessage();
                this.getNewFile(this.chatID);
                this.updateMessage(this.chatID);
            } else {
                this.agentID = list.agent_id;
                this.chatID = list.id;
                this.getNewMessage();
                this.getNewFile(this.chatID);
                this.updateMessage(this.chatID);
            }
        }, (err) => {
            this.toast.showToastFromError(err);
        });
    }

    groupMessage(messages) {
        for (let i = 0; i < messages.length; i++) {
            const files = [];
            for (let j = 0; j < messages.length; j++) {
                if (messages[i].id === messages[j].id) {
                    files.push({file: messages[j].file, name: messages[j].name});
                }
            }
            messages[i].files = files;
        }

        const newMsg = [];
        for (let i = 0; i < messages.length; i++) {
            let allow = true;
            for (let j = 0; j < newMsg.length; j++) {
                if (messages[i].id === newMsg[j].id) {
                    allow = false;
                }
            }
            if (allow) {
                newMsg.push(messages[i]);
            }
        }

        this.messages = newMsg;

        for (let i = 0; i < this.messages.length; i++) {
            if (!this.unreadPos && this.messages[i].read_at === null) {
                this.unreadPos = i;
            }
        }

        setTimeout(() => {
            if (document.getElementById('chat-messages')) {
                const message = document.getElementById('message' + this.unreadPos);
                if (this.unreadPos && message) {
                    document.getElementById('chat-messages').scrollTop = message.offsetTop - document.getElementById('chat-messages').offsetTop;
                } else {
                    document.getElementById('chat-messages').scrollTop = document.getElementById('chat-messages').scrollHeight;
                }
                this.showChat = true;
            }
        }, 1000);
    }

    getPathFile(e, filePath) {
        e.preventDefault();
        const file = {'name': filePath};
        this.documentsService.getFile(file).subscribe(
            (res: any) => {
                if (res) {
                    const reader = new FileReader();
                    reader.readAsDataURL(res);
                    reader.onloadend = () => {
                        const base64data = reader.result;
                        const w = window.open('about:blank');
                        if (typeof base64data === 'string') {
                            w.document.body.appendChild(w.document.createElement('img')).src = base64data;
                        }
                    }
                }
            },
            err => {
                this.toast.showToastFromError(err);
            }
        );
    }

    sendMessage(allow?) {
        const formattedMsg = this.newMessage?.replace(/^\s+|\s+$/g, '');
        if ((!formattedMsg || formattedMsg === '' || !formattedMsg.length) && !allow) {
            // this.toast.showErrorToast({title: 'Вы не заполнили поле'});
        } else {
            if (this.messages.length > 1) {
                this.agentID = this.messages[this.messages.length - 1].agent_id;
            }
            const data = {
                message: formattedMsg,
                agent: this.agentID,
                id: this.clientID,
                reply_to: this.clientID
            };
            this.chat.createMessage(data).subscribe((msg) => {
                this.newMessage = '';
                this.storage.chatCounter = 0;
                if (allow) {
                    this.uploadFileReq();
                }

            }, (err) => {
                this.toast.showToastFromError(err);
            });
        }
    }

    getNewMessage() {
        this.websocket.new_message(this.clientID).subscribe(
            msg => {
                if (this.messages.length === 0) {
                    this.messages[0] = new Message().setFromApiModel(msg);
                } else {
                    this.messages.push(new Message().setFromApiModel(msg));
                }
                setTimeout(() => {
                    if (document.getElementById('chat-messages')) {
                        document.getElementById('chat-messages').scrollTop = document.getElementById('chat-messages').scrollHeight;
                    }
                }, 100);
            },
            err => {
                console.log(err);
                this.toast.showToastFromError(err);
            }
        );
    }

    uploadFile(files) {
        const sizeBytes = 16 * 1024 * 1024;
        const extension = ['pdf', 'xls', 'xlsx', 'csv', 'odt', 'ppt', 'pptx', 'txt', 'doc', 'docx', 'rtf', 'jpg', 'jpeg', 'png'];
        const errMessage = 'Размер фото не должен превышать 16 Мб, допустимый формат pdf, xls, xlsx, csv, odt, ppt, pptx, ' +
            'txt, doc, docx, rtf, jpg, jpeg или png';
        try {
            if (files.item(0)) {
                this.fileUpload = new FormData();
                const file = files.item(0);
                this.fileName = file.name;

                if (file.size > sizeBytes || extension.indexOf(file.name.split('.').slice(-1)[0].toLowerCase()) < 0) {
                    this.toast.showErrorToast({title: errMessage});
                    return false;
                }
                this.fileUpload.append('file', file);
                this.fileUpload.append('name', file.name);
                this.fileUpload.append('origin_name', this.fileName ? this.fileName : '');
            }
        } catch (e) {
            this.toast.showErrorToast({title: errMessage});
            this.fileUpload = null;
        }
        this.uploadFileReq();

    }

    getLastClientMsg() {
        let messageId = '';
        this.messages.forEach((msg) => {
            if (msg.reply_to === this.clientID) {
                messageId = msg.id;
            }
        });

        return messageId;
    }

    uploadFileReq() {
        this.fileUpload.append('id', this.clientID);
        this.fileUpload.append('chat_id', this.chatID);
        const data = {
            message: '',
            agent: this.agentID,
            id: this.clientID,
            reply_to: this.clientID,
        };
        this.chat.createMessage(data).subscribe((msg) => {
            this.fileUpload.append('message_id', msg.id);
            this.chat.uploadFile(this.fileUpload).subscribe((res) => {
                this.fileName = '';
                this.fileUpload = '';
                this.toast.showToast({title: 'Файл отправлен'});
            }, (err) => {
                this.toast.showToastFromError(err);
            });
        }, (err) => {
            this.toast.showToastFromError(err);
        });
    }

    getNewFile(chatID) {
        this.websocket.new_file(chatID).subscribe(
            msg => {
                const file = new Attachment().setFromApiModel(msg);
                this.messages.forEach((message) => {
                    if (message.id === file.message_id) {
                        if (!message.files) {
                            message.files = [];
                            message.files[0] = {file: file.file, name: file.name, id: file.id};
                        } else {
                            message.files.push({file: file.file, name: file.name, id: file.id});
                        }
                    }
                });
                setTimeout(() => {
                    if (document.getElementById('chat-messages')) {
                        document.getElementById('chat-messages').scrollTop = document.getElementById('chat-messages').scrollHeight;
                    }
                }, 100);
            },
            err => {
                console.log(err);
                this.toast.showToastFromError(err);
            }
        );
    }

}
